/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFRankingItem } from './CRSFRankingItem';
import {
    CRSFRankingItemFromJSON,
    CRSFRankingItemFromJSONTyped,
    CRSFRankingItemToJSON,
} from './CRSFRankingItem';

/**
 * 
 * @export
 * @interface CRSFPopularityRankingResult
 */
export interface CRSFPopularityRankingResult {
    /**
     * 
     * @type {string}
     * @memberof CRSFPopularityRankingResult
     */
    domain: string;
    /**
     * 
     * @type {Array<CRSFRankingItem>}
     * @memberof CRSFPopularityRankingResult
     */
    rankings: Array<CRSFRankingItem>;
}

/**
 * Check if a given object implements the CRSFPopularityRankingResult interface.
 */
export function instanceOfCRSFPopularityRankingResult(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "domain" in value;
    isInstance = isInstance && "rankings" in value;

    return isInstance;
}

export function CRSFPopularityRankingResultFromJSON(json: any): CRSFPopularityRankingResult {
    return CRSFPopularityRankingResultFromJSONTyped(json, false);
}

export function CRSFPopularityRankingResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFPopularityRankingResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'domain': json['domain'],
        'rankings': ((json['rankings'] as Array<any>).map(CRSFRankingItemFromJSON)),
    };
}

export function CRSFPopularityRankingResultToJSON(value?: CRSFPopularityRankingResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'domain': value.domain,
        'rankings': ((value.rankings as Array<any>).map(CRSFRankingItemToJSON)),
    };
}

